/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Box,
  makeStyles,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { setTechModelAction } from '../../redux/techModel.js';
import { ReactComponent as ChevronDownIcon } from '../../img/caret.svg';
import Button from '../../components/Button';
import { fetchUserData } from '../../redux/user';
import './model-form.scss';

const useStyles = makeStyles((theme) => ({
  container: {
    borderTop: '2px solid #cfdae2',
    position: 'relative',
    marginTop: 8,
    marginBottom: 16,
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
      marginTop: 30,
    },
  },
  title: {
    fontSize: '16px',
    color: '#004987',
    margin: '-20px',
    padding: '0 10px',
    backgroundColor: '#fff',
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px',
    },
  },
  legendIcon: {
    backgroundColor: 'white',
    width: 38,
    height: 38,
    border: '2px solid lightgrey',
    borderRadius: '50%',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'lightgrey',
    position: 'absolute',
    right: 30,
    top: -19,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  label: {
    fontSize: '20px',
    color: '#717271',
    top: '-15px',
  },
  phoneLabel: {
    fontSize: '20px',
    color: '#717271',
    top: '-36px',
    lineHeight: 'inherit',
    width: '370px',
    [theme.breakpoints.up('sm')]: {
      width: '603px',
    },
    [theme.breakpoints.up('md')]: {
      width: '500px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '566px',
    },
  },
  formControl: {
    marginTop: '24px',
    padding: '0',
  },
  input: {
    color: '#323232',
    fontSize: '16px',
    margiTop: '32px',
  },
  checkboxHelperText: {
    fontWeight: 'bold',
    fontSize: '10px',
    fontStyle: 'italic',
    color: '#323232',
  },
  checkboxFormControl: {
    marginTop: '18px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  selectIcon: {
    position: 'absolute',
    left: '95%',
    top: '5px',
    zIndex: '-1000',
  },
}));

let validationSchema;

export default function PersonalInfoForm(props, { submitForm }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [info, setInfo] = useState();
  const [canSubmit, setSubmit] = useState(false);

  const { email, phone, phoneCompany } = info || {};

  const initialValues = {
    phoneBrand: '',
    phoneModel: '',
    techBrand: '',
    techModel: '',
  };

  const totalState = useSelector((state) => state);

  const showNotebook =
    totalState.insurances.selected.insuranceProductId === '3675' ||
    totalState.insurances.selected.insuranceProductId === '3676'
      ? true
      : false;

  if (showNotebook) {
    validationSchema = Yup.object({
      phoneBrand: Yup.string().required('Campo obligatorio'),
      phoneModel: Yup.string().required('Campo obligatorio'),
      techBrand: Yup.string().required('Campo obligatorio'),
      techModel: Yup.string().required('Campo obligatorio'),
    });
  } else {
    validationSchema = Yup.object({
      phoneBrand: Yup.string().required('Campo obligatorio'),
      phoneModel: Yup.string().required('Campo obligatorio'),
    });
  }

  const {
    values,
    errors,
    touched,
    handleBlur,
    setFieldValue,
    handleSubmit,
    isSubmitting,
    validateForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
  });

  function handleChange(e) {
    const key = e.target.name;
    const value = e.target.value;
    setFieldValue(key, value);
  }

  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    async function validateForm() {
      const a = await handleSubmit();
    }
    if (!isSubmitting) {
      validateForm();
    }
  }, [submitForm]);

  const hasError = (input) => (errors[input] && touched[input] ? true : false);

  async function handleClick() {
    const showErrors = await validateForm();

    if (Object.keys(showErrors).length === 0) {
      const submitting = await handleSubmit();
      dispatch(setTechModelAction(values));
      dispatch(fetchUserData());
      history.push('/resumen');
    } else {
      await handleSubmit();
    }
  }

  return (
    <>
      <Box classes={{ root: classes.container }}>
        <Box classes={{ root: classes.legendIcon }}>
          <img
            src={require('../../img/pencil.svg')}
            alt=''
            style={{ width: '50%' }}
          />
        </Box>
        <Box display='flex' justifyContent='center' mt='8px'>
          <Box
            classes={{ root: classes.title }}
            component='h3'
            fontWeight='fontWeightBold'
          >
            Completá los datos de tu smartphone{' '}
          </Box>
        </Box>
        <Box width='90%' mx='auto' mb='24px'>
          <form
            onSubmit={handleSubmit}
            noValidate
            autoComplete='off'
            className='model-form-container'
          >
            <FormControl classes={{ root: classes.formControl }}>
              <InputLabel
                shrink
                focused={false}
                htmlFor='phoneBrand'
                classes={{ root: classes.label }}
              >
                Marca
              </InputLabel>
              <Input
                id='phoneBrand'
                name='phoneBrand'
                value={values.brand}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError('phoneBrand')}
                classes={{ root: classes.input }}
              />
              <FormHelperText error={hasError('phoneBrand')}>
                {hasError('phoneBrand') && errors.phoneBrand}
              </FormHelperText>
            </FormControl>
            <FormControl classes={{ root: classes.formControl }}>
              <InputLabel
                shrink
                focused={false}
                htmlFor='phoneModel'
                classes={{ root: classes.label }}
              >
                Modelo
              </InputLabel>
              <Input
                id='phoneModel'
                name='phoneModel'
                value={values.phoneModel}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError('phoneModel')}
                classes={{ root: classes.input }}
              />
              <FormHelperText error={hasError('phoneMmodel')}>
                {hasError('phoneModel') && errors.phoneModel}
              </FormHelperText>
            </FormControl>
          </form>
        </Box>
      </Box>

      {showNotebook && (
        <Box classes={{ root: classes.container }}>
          <Box classes={{ root: classes.legendIcon }}>
            <img
              src={require('../../img/pencil.svg')}
              alt=''
              style={{ width: '50%' }}
            />
          </Box>
          <Box display='flex' justifyContent='center' mt='8px'>
            <Box
              classes={{ root: classes.title }}
              component='h3'
              fontWeight='fontWeightBold'
            >
              Completá los datos de tu notebook o tablet{' '}
            </Box>
          </Box>
          <Box width='90%' mx='auto' mb='24px'>
            <form
              onSubmit={handleSubmit}
              noValidate
              autoComplete='off'
              className='model-form-container'
            >
              <FormControl classes={{ root: classes.formControl }}>
                <InputLabel
                  shrink
                  focused={false}
                  htmlFor='techBrand'
                  classes={{ root: classes.label }}
                >
                  Marca
                </InputLabel>
                <Input
                  id='techBrand'
                  name='techBrand'
                  value={values.techbrand}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={hasError('techBrand')}
                  classes={{ root: classes.input }}
                />
                <FormHelperText error={hasError('techBrand')}>
                  {hasError('techBrand') && errors.techBrand}
                </FormHelperText>
              </FormControl>
              <FormControl classes={{ root: classes.formControl }}>
                <InputLabel
                  shrink
                  focused={false}
                  htmlFor='techModel'
                  classes={{ root: classes.label }}
                >
                  Modelo
                </InputLabel>
                <Input
                  id='techModel'
                  name='techModel'
                  value={values.techModel}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={hasError('techModel')}
                  classes={{ root: classes.input }}
                />
                <FormHelperText error={hasError('techModel')}>
                  {hasError('techModel') && errors.techModel}
                </FormHelperText>
              </FormControl>
            </form>
          </Box>
        </Box>
      )}
      <div className='button-container'>
        <Button color='primary' onClick={() => props.closeModal(false)}>
          Volver
        </Button>
        <Button color='secondary' onClick={() => handleClick()}>
          Continuar
        </Button>
      </div>
    </>
  );
}
